export default __webpack_public_path__ + "static/media/copy-item.9e3f3a9f.svg";